module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/2fddbf3b6b883bd96f85ed05cc1dc1a7.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Gold/Gold3.svg
// module id = eKZK
// module chunks = 1